import {openAdapted, topWindowAdapted} from "../../../adapters/WindowAdapter";
import {
    SocialSharingWidgetStyleCategory, SocialSharingWidgetStyleName, SocialSharingWidgetNetwork
} from "../../../models";

const WINDOW_POPUP_NAME = "social-window";
const WINDOW_POPUP_FEATURES = "location=1,status=1,scrollbars=1,width=500,height=380";
const PINTEREST_PIN_MARKLET_JS_PATH = "//assets.pinterest.com/js/pinmarklet.js";

const actualNetworkUrls = {
    [SocialSharingWidgetNetwork.Facebook]:   "//www.facebook.com/sharer.php?u=",
    [SocialSharingWidgetNetwork.Twitter]:    "//twitter.com/?status=",
    [SocialSharingWidgetNetwork.Pinterest]:  "",
    [SocialSharingWidgetNetwork.Linkedin]:   "//www.linkedin.com/shareArticle?mini=true&url="
}

// URLs opened from the social sharing popup window. Pinterest will open a pinmarklet overlay, not a link.
const networkUrls = {
    ...actualNetworkUrls,
    [SocialSharingWidgetNetwork.GooglePlus]: "//plus.google.com/share?url=",
};

export const ACTUAL_NETWORKS = Object.keys(actualNetworkUrls);

export const STYLES: ReadonlyArray<{
    name: SocialSharingWidgetStyleName;
    category: SocialSharingWidgetStyleCategory;
}> = [
    {
        name: SocialSharingWidgetStyleName.Squared,
        category: SocialSharingWidgetStyleCategory.FlatSquared
    },
    {
        name: SocialSharingWidgetStyleName.Rounded,
        category: SocialSharingWidgetStyleCategory.FlatRounded
    },
    {
        name: SocialSharingWidgetStyleName.Isolated,
        category: SocialSharingWidgetStyleCategory.Isolated
    },
    {
        name: SocialSharingWidgetStyleName.Circle,
        category: SocialSharingWidgetStyleCategory.FlatCircle
    },
    {
        name: SocialSharingWidgetStyleName.White,
        category: SocialSharingWidgetStyleCategory.WhiteCircle
    },
    {
        name: SocialSharingWidgetStyleName.Black,
        category: SocialSharingWidgetStyleCategory.BlackCircle
    }
];

/**
 * Opens the real share functionality.
 *
 * @param network - The network to open.
 * @param shareURL - The url to share.
 */
export function openShareLink(network: SocialSharingWidgetNetwork, shareURL?: string) {
    const win = topWindowAdapted(false);

    shareURL = shareURL || win.location.href || window.location.href;

    if (network !== SocialSharingWidgetNetwork.Pinterest) {
        const a = win.document.createElement("a");
        a.href = networkUrls[network] + encodeURIComponent(shareURL);

        openAdapted(a.href, WINDOW_POPUP_NAME, WINDOW_POPUP_FEATURES);
    } else {
        // Insert the pinmarklet.js on the parent page, so that the Pinterest pinnable overlay will be displayed.
        const e = win.document.createElement("script");
        e.setAttribute("id", "zmags-pinmarklet");
        e.setAttribute("type", "text/javascript");
        e.setAttribute("charset", "UTF-8");
        e.setAttribute("src", `${PINTEREST_PIN_MARKLET_JS_PATH}?r=${Math.random() * 99999999}`);
        win.document.body.appendChild(e);
    }
}



// WEBPACK FOOTER //
// ./src/shared/xp/components/widgets/socialsharing/SocialSharingService.ts